import type {QuoteSalesOptions, QuoteSuggestiveSellingTarget} from '../types';

export interface CreateQuoteTargetParams {
    customerId: number;
    orderId: number;
    warehouseCode?: string;
    getOrderItems: QuoteSuggestiveSellingTarget['getOrderItems'];
    onOrderUpdated: QuoteSuggestiveSellingTarget['onOrderUpdated'];
    salesOptions: QuoteSalesOptions;
}

export function createQuoteTarget(params: CreateQuoteTargetParams): QuoteSuggestiveSellingTarget {
    return {
        type: 'quote',
        customerId: params.customerId,
        orderId: params.orderId,
        warehouseCode: params.warehouseCode,
        getOrderItems: params.getOrderItems,
        onOrderUpdated: params.onOrderUpdated,
        salesOptions: params.salesOptions,
    };
}
